import { getShopSalesReport } from "@/helpers/service/api/report";
import { json2csv_fn, taxRatesMap, toThousands} from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";


export function exportCSV_fn(requestParma) {
  getShopSalesReport(requestParma).then(res => {
    if (res.data.consignmentRecords.length > 0 || res.data.salesItemRecords.length > 0) {
      const fields = [
        {
          label: locale("accountPayable.client"),
          value: "clientName"
        },
        {
          label: locale("trans.koisk.salesgroup"),
          value: "salesGroupName"
        },
        {
          label: locale("global.department"),
          value: "groupName"
        },
        {
          label: locale("inventoryLog.name"),
          value: "name"
        },
        {
          label: locale("report.shopSale.cost"),
          value: "cost"
        },
        {
          label: locale("report.shopSale.taxRate"),
          value: "taxRate"
        },
        {
          label: locale("report.shopSale.unitPrice"),
          value: "unitPrice"
        },
        {
          label: locale("global.quantity"),
          value: "qty"
        },
        {
          label: locale("report.shopSale.keshang"),
          value: "amount"
        },
        {
          label: locale("report.shopSale.culi"),
          value: "culi"
        },
      ];
      let _arrConsignment = [];
      let _arrSalesItem = [];
      // CONSIGNMENT
      res.data.consignmentRecords.forEach(client => {
        client.salesGroupRecords.forEach(salesGroup => {
          salesGroup.groupRecords.forEach(group => {
            group.shopRecords.forEach(shop => {
              _arrConsignment.push({
                clientName: client.clientName,
                salesGroupName: salesGroup.salesGroupName,
                groupName: group.groupName,
                name: shop.name,
                cost: shop.cost,
                taxRate: taxRatesMap[shop.taxRate],
                unitPrice: shop.unitPrice,
                qty: shop.qty,
                amount: shop.amount,
                culi: (shop.unitPrice - shop.cost) * shop.qty
              });
            });
             _arrConsignment.push({
              type: "group",
              clientName: client.clientName,
              salesGroupName: salesGroup.salesGroupName,
              groupName: locale("report.group.subTotal"),
              name: "",
              cost: "",
              taxRate: "",
              unitPrice:"",
              qty:  group.shopRecords.reduce((total, item) => total + item.qty, 0),
              amount: group.shopRecords.reduce((total, item) => total + item.amount, 0),
              culi: group.shopRecords.reduce((total, item) => total + (item.unitPrice - item.cost) * item.qty, 0),
            });
          });
          _arrConsignment.push({
            type: "salesGroup",
            clientName: client.clientName,
            salesGroupName: locale("report.salesGroup.subTotal"),
            groupName: "",
            name: "",
            cost: "",
            taxRate: "",
            unitPrice:"",
            qty:  _arrConsignment.filter(item => item.type === "group" && item.clientName === client.clientName).reduce((total, item) => total + item.qty, 0),
            amount: _arrConsignment.filter(item => item.type === "group" && item.clientName === client.clientName).reduce((total, item) => total + item.amount, 0),
            culi:  _arrConsignment.filter(item => item.type === "group" && item.clientName === client.clientName).reduce((total, item) => total + item.culi, 0),
          });
        });
        _arrConsignment.push({
          type: "client",
          clientName: locale("report.client.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice:"",
          qty:  _arrConsignment.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.qty, 0),
          amount: _arrConsignment.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.amount, 0),
          culi:  _arrConsignment.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.culi, 0),
        });
      });
      if (_arrConsignment.length > 0) {
        _arrConsignment.push({
          type: "subTotal",
          clientName: locale("report.shopSale.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice: "",
          qty: _arrConsignment.filter(item => item.type === "client").reduce((total, item) => total + item.qty, 0),
          amount: _arrConsignment.filter(item => item.type === "client").reduce((total, item) => total + item.amount, 0),
          culi: _arrConsignment.filter(item => item.type === "client").reduce((total, item) => total + item.culi, 0),
        });
      }
      // SALESITEM
      res.data.salesItemRecords.forEach(client => {
        client.salesGroupRecords.forEach(salesGroup => {
          salesGroup.groupRecords.forEach(group => {
            group.shopRecords.forEach(shop => {
              _arrSalesItem.push({
                clientName: client.clientName,
                salesGroupName: salesGroup.salesGroupName,
                groupName: group.groupName,
                name: shop.name,
                cost:shop.cost,
                taxRate: taxRatesMap[shop.taxRate],
                unitPrice: shop.unitPrice,
                qty: shop.qty,
                amount: shop.amount,
                culi: (shop.unitPrice - shop.cost) * shop.qty
              });
            });
             _arrSalesItem.push({
              type: "group",
              clientName: client.clientName,
              salesGroupName: salesGroup.salesGroupName,
              groupName: locale("report.group.subTotal"),
              name: "",
              cost: "",
              taxRate: "",
              unitPrice:"",
              qty:  group.shopRecords.reduce((total, item) => total + item.qty, 0),
              amount: group.shopRecords.reduce((total, item) => total + item.amount, 0),
              culi: group.shopRecords.reduce((total, item) => total + (item.unitPrice - item.cost) * item.qty, 0),
            });
          });
          _arrSalesItem.push({
            type: "salesGroup",
            clientName: client.clientName,
            salesGroupName: locale("report.salesGroup.subTotal"),
            groupName: "",
            name: "",
            cost: "",
            taxRate: "",
            unitPrice:"",
            qty:  _arrSalesItem.filter(item => item.type === "group" && item.clientName === client.clientName && item.salesGroupName === salesGroup.salesGroupName).reduce((total, item) => total + item.qty, 0),
            amount:  _arrSalesItem.filter(item => item.type === "group" && item.clientName === client.clientName && item.salesGroupName === salesGroup.salesGroupName).reduce((total, item) => total + item.amount, 0),
            culi:  _arrSalesItem.filter(item => item.type === "group" && item.clientName === client.clientName && item.salesGroupName === salesGroup.salesGroupName).reduce((total, item) => total + item.culi, 0),
          });
        });
        _arrSalesItem.push({
          type: "client",
          clientName: locale("report.client.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice:"",
          qty:  _arrSalesItem.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.qty, 0),
          amount: _arrSalesItem.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.amount, 0),
          culi:  _arrSalesItem.filter(item => item.type === "salesGroup" && item.clientName === client.clientName).reduce((total, item) => total + item.culi, 0),
        });
      });
      if (_arrSalesItem.length > 0) {
        _arrSalesItem.push({
          type: "subTotal",
          clientName: locale("report.shopSale.subTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice: "",
          qty:  _arrSalesItem.filter(item => item.type === "client").reduce((total, item) => total + item.qty, 0),
          amount: _arrSalesItem.filter(item => item.type === "client").reduce((total, item) => total + item.amount, 0),
          culi: _arrSalesItem.filter(item => item.type === "client").reduce((total, item) => total + item.culi, 0),
        });
      }
      if (_arrSalesItem.length > 0 || _arrConsignment.length > 0) {
        _arrSalesItem.push({
          type: "allTotal",
          clientName: locale("report.shopSale.allTotal"),
          salesGroupName: "",
          groupName: "",
          name: "",
          cost: "",
          taxRate: "",
          unitPrice: "",
          qty: _arrConsignment.filter(item => item.type === "subTotal").reduce((total, item) => total + item.qty, 0) +  _arrSalesItem.filter(item => item.type === "subTotal").reduce((total, item) => total + item.qty, 0),
          amount: _arrConsignment.filter(item => item.type === "subTotal").reduce((total, item) => total + item.amount, 0) +  _arrSalesItem.filter(item => item.type === "subTotal").reduce((total, item) => total + item.amount, 0),
          culi: _arrConsignment.filter(item => item.type === "subTotal").reduce((total, item) => total + item.culi, 0) +  _arrSalesItem.filter(item => item.type === "subTotal").reduce((total, item) => total + item.culi, 0),
        });
      }
      // _arrConsignment.forEach(item => {
      //   if (item.cost) {
      //     item.cost = "¥" + toThousands(item.cost);
      //   }
      //   if (item.unitPrice) {
      //     item.unitPrice = "¥" + toThousands(item.unitPrice);
      //   }
      //   item.amount = "¥" + toThousands(item.amount);
      //   item.culi = "¥" + toThousands(item.culi);
      // });
      // _arrSalesItem.forEach(item => {
      //   if (item.cost) {
      //     item.cost = "¥" + toThousands(item.cost);
      //   }
      //   if (item.unitPrice) {
      //     item.unitPrice = "¥" + toThousands(item.unitPrice);
      //   }
      //   item.amount = "¥" + toThousands(item.amount);
      //   item.culi = "¥" + toThousands(item.culi);
      // });
      let csvData = _arrConsignment.concat(_arrSalesItem);
      const { startDate, endDate } = requestParma
      json2csv_fn(csvData, fields, 
      // moment().format("YYYYMMDDHHmm") + "_" + locale("report.shopSale.shopSale")
      getExportName_fn(
        locale("report.shopSale.shopSale"),
        '',
        '',
        '',
        `${moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(endDate).day()]}）`,
        res.data.cinemaName,
        moment().format('YYYYMMDDHHmm')
      )
      );
    }
  });
}